import styled from "styled-components";
import ThemeColors from "../../themes/colors";

export const StyledTextArea = styled.div`
  .ant-input {
    font-size: 16px;
    border-radius: 12px;
    padding: 11px;
    font-family: "Urbanist";
    font-weight: 500;
  }

  .ant-input-outlined {
    background-color: ${ThemeColors.Gray400};
    border-color: ${ThemeColors.Gray500};
  }
`;
